import {
  reactQueryDelete,
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { internalApi } from "../helpers/urlHelpers";
import type { MarketingEmailTemplateParams } from "../types/MarketingEmailTemplates";

type MarketingEmailTemplateDetailURLParams = Parameters<
  typeof internalApi.marketingEmailTemplates.item
>[0];

interface UpdateMarketingEmailTemplateParams
  extends MarketingEmailTemplateDetailURLParams {
  body: MarketingEmailTemplateParams;
}

const list = ({
  params = {},
}: Parameters<typeof internalApi.marketingEmailTemplates.index>[0] = {}) =>
  reactQueryGet(internalApi.marketingEmailTemplates.index({ params }));

const create = (body: MarketingEmailTemplateParams) =>
  reactQueryPost(internalApi.marketingEmailTemplates.index(), body);

const show = ({ id }: MarketingEmailTemplateDetailURLParams) =>
  reactQueryGet(internalApi.marketingEmailTemplates.item({ id }));

const update = ({ id, body }: UpdateMarketingEmailTemplateParams) =>
  reactQueryPut(internalApi.marketingEmailTemplates.item({ id }), body);

const deleteTemplate = ({ id }: MarketingEmailTemplateDetailURLParams) =>
  reactQueryDelete(internalApi.marketingEmailTemplates.item({ id }));

const exists = () =>
  reactQueryGet(internalApi.marketingEmailTemplates.exists());

const disableSaveEmailTemplatePrompt = (body: {
  disable_save_email_template_prompt: boolean;
}) =>
  reactQueryPatch(
    internalApi.marketingEmailTemplates.disableSaveEmailTemplatePrompt(),
    body,
  );

export const marketingEmailTemplatesApi = {
  list,
  create,
  show,
  update,
  deleteTemplate,
  exists,
  disableSaveEmailTemplatePrompt,
};
